import React from 'react'

const Right = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M9.75 5.4165L11.9167 7.94392M9.75 20.5832L16.25 12.9998L14.625 11.104" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5"></path>
</svg>
    )
}

export default Right
